import { useAuth } from '@/hooks/useAuth';
import { PageContainer } from '@/components/common/PageContainer';
import { formatDate } from '@/lib/formatters';
import { AdminDashboard } from '@/components/features/dashboard/AdminDashboard';
import { CarrierDashboard } from '@/components/features/dashboard/CarrierDashboard';
import { TenantDashboard } from '@/components/features/dashboard/TenantDashboard';
import { useI18n } from '@/contexts/I18nContext';

export default function Dashboard() {
  const { user } = useAuth();
  const { tp } = useI18n();

  return (
    <PageContainer>
      {/* Welcome Section */}
      <div className="mb-6">
        <h1 className="text-2xl md:text-3xl font-bold mb-1">{tp.dashboard.welcomeMessage.replace('{name}', user?.display_name ?? '')}</h1>
        <p className="text-sm text-muted-foreground">
          {formatDate(new Date(), 'EEEE، dd MMMM yyyy')}
        </p>
      </div>

      {user?.role === 'admin' && <AdminDashboard />}
      {user?.role === 'carrier' && <CarrierDashboard />}
      {user?.role === 'tenant' && <TenantDashboard />}
    </PageContainer>
  );
}
